import { FC } from "react";
import { NotificationsListFieldsRecordType, testRegistry } from "src/api/config/notifications.config";
import { TestRegistryItem } from "./TestRegistryItem";
import { useAppSelector } from "src/hooks/redux";
import { RootState } from "src/store/rootReducer";
import { selectGetStatus } from "src/modules/spItems/selectors";
import { EmptyList } from "src/components/EmptyList";
import Loading from "src/components/Loading";

interface IProps {
  testName: string;
  selectedCollection: any;
  testsList: NotificationsListFieldsRecordType["TestRegistry"][];
}

export const TestRegistryList: FC<IProps> = ({ testName, selectedCollection, testsList }) => {
  const status = useAppSelector((state: RootState) => selectGetStatus(state, testRegistry));

  const cleanedTestName = testName.replace(/\s+/g, "").toLowerCase();

  const filteredListTests = testsList.filter(
    (test: any) =>
      (cleanedTestName.length === 0 || test.Title.toLowerCase().includes(cleanedTestName)) && (Object.keys(selectedCollection).length === 0 || test.Collections.Title === selectedCollection.Title)
  );

  return (
    <div className="mb-5">
      <form>
        {status === "LOADING" ? (
          <div className="pt-4">
            <Loading />
          </div>
        ) : filteredListTests.length ? (
          filteredListTests.map((test: NotificationsListFieldsRecordType["TestRegistry"]) => <TestRegistryItem key={test.ID} test={test} />)
        ) : (
          <EmptyList title="Тесты не найдены" />
        )}
      </form>
    </div>
  );
};
